import React, {useEffect, useMemo, useState} from 'react'
import PropTypes from 'prop-types';
import Page from "components/Page";
import GridBlock from "components/GridBlock";
import Tr from "translations/Translations";
import BoldTypography from "components/BoldTypography";
import {makeStyles, Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import Workspace from "components/Workspace";
import AnnualReportsService from "services/AnnualReportsService";
import WorkableButton from "components/button/WorkableButton";
import AddIcon from '@material-ui/icons/Add'
import AddAnnualReportPopup from "./components/AddAnnualReportPopup";
import RouterPath from "libs/RouterPath";
import {createSelectItem} from "components/Select";
import SimpleSelect from "components/SimpleSelect";
import {useParams} from "react-router";
import AnnualReportListTableRow from "./components/AnnualReportListTableRow";
import {connect} from "react-redux";
import Loading from "components/Loading";

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    },
    versionColumn: {
        width: 50
    },
    orgColumn: {
    },
    statusColumn: {
        width: 270
    },
    numberColumn: {
        width: 180
    },
    dateTimeColumn: theme.components.table.dateTimeColumn,
    buttonColumn: theme.components.table.buttonColumn,
    select: {
        width: 200
    },
    versionsCell: {
        background: theme.palette.background.greyBackground
    },
    versionsTable: {
        background: theme.palette.background.paper
    }
}));

const empty_object = {}

function AnnualReportsList(
    {
        reportsList = empty_object
    }
) {
    const classes = useStyles();
    const params = useParams();
    const [addPopup, setAddPopup] = useState(false);
    const [working, setWorking] = useState(false);
    const items = useMemo(() => {
        const years = [];
        if (reportsList.minYear && reportsList.maxYear) {
            for (let i = reportsList.maxYear; i >= reportsList.minYear; i--) {
                years.push(createSelectItem(`${i}`, `${i}`));
            }
        } else {
                years.push(createSelectItem(params.year, params.year));
        }
        return years;
    }, [reportsList, params.year])


    useEffect(() => {
        setWorking(true);
        AnnualReportsService.getAnnualReportList(params.year).finally(() => setWorking(false));
        return () => {
            AnnualReportsService.clearResources(AnnualReportsService.ANNUAL_REPORT_LIST_RESOURCE_ID)
        }
    }, [params.year]);

    const closeAddPopup = (added) => {
        if (added) {
            AnnualReportsService.getAnnualReportList(params.year).finally(() => setAddPopup(false))
        } else {
            setAddPopup(null)
        }
    }

    return (<Page className={classes.root}>
        <Workspace title={`${Tr('annual_reports')} ${params.year}`}>

            <GridBlock justify='space-between'>
                <SimpleSelect
                    items={items}
                    label={Tr('annual_report_year')}
                    className={classes.select}
                    value={params.year}
                    disabled={working}
                    onChange={(e) => RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.annualReport.MP_ANNUAL_REPORT_YEAR_LIST, {year: e.target.value}))}
                />
                <WorkableButton disabled={working || !reportsList.hasEdit} Icon={AddIcon} variant='contained'
                                onClick={() => setAddPopup(true)}>{Tr('annual_report_add') + " " + params.year}</WorkableButton>
            </GridBlock>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.orgColumn}>{Tr("organizational_unit")}</TableCell>
                        <TableCell className={classes.numberColumn}>{Tr("number_of_processing")}</TableCell>
                        <TableCell className={classes.versionColumn}>{Tr("version")}</TableCell>
                        <TableCell className={classes.dateTimeColumn}>{Tr("add_data")}</TableCell>
                        <TableCell className={classes.dateTimeColumn}>{Tr("modyfication_date")}</TableCell>
                        <TableCell className={classes.dateTimeColumn}>{Tr("transfer_date")}</TableCell>
                        <TableCell className={classes.statusColumn}>{Tr("status")}</TableCell>
                        <TableCell className={classes.buttonColumn}></TableCell>
                        <TableCell className={classes.buttonColumn}></TableCell>
                        <TableCell className={classes.buttonColumn}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        !reportsList.items ? <TableRow><TableCell colSpan={10}><Loading/></TableCell></TableRow> :
                            <>

                                {reportsList.items.map((x, i) => (<AnnualReportListTableRow
                                    key={x.identity}
                                    classes={classes}
                                    report={x}
                                    parentWorking={working}
                                    hasEdit={reportsList.hasEdit}
                                />))}
                                {
                                    !reportsList.items.length &&
                                    <TableRow><TableCell colSpan={10}><BoldTypography align='center' variant="h6">{Tr('no_options')}</BoldTypography></TableCell></TableRow>
                                }
                            </>
                    }
                </TableBody>
            </Table>

            {
                addPopup && <AddAnnualReportPopup onClose={closeAddPopup}/>
            }

        </Workspace>
    </Page>)
}

AnnualReportsList.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    reportsList: state.resources[AnnualReportsService.ANNUAL_REPORT_LIST_RESOURCE_ID]
}))(AnnualReportsList);